<template>
  <div>
    <vs-popup-custom
      :title="$t('document') | capitalize"
      color="danger"
      :buttonCloseHidden="true"
      :active.sync="value"
      :persistent="true"
    >
      <div :id="loadingPage" class="vs-con-loading__container">
        <form class="px-2">
          <div class="popup-custom-h-200">
            <vs-row class="mb-5">
              <vs-col vs-xs="12" vs-sm="3" vs-lg="3">
                <span>{{ $t('name') | capitalize }}</span>
              </vs-col>
              <vs-col vs-xs="12" vs-sm="9" vs-lg="9">
                <vs-input
                  :placeholder="$t('name') | capitalize"
                  class="w-full"
                  maxlength="120"
                  v-model="form.name"
                />
              </vs-col>
            </vs-row>

            <vs-row class="mb-5">
              <vs-col vs-xs="12" vs-sm="3" vs-lg="3">
                <span>{{ $tc('frequency') | capitalize }}</span>
              </vs-col>
              <vs-col vs-xs="12" vs-sm="9" vs-lg="9">
                <v-select
                  v-model="form.frequency"
                  :options="frequencies"
                  :reduce="(item) => item.id"
                  label="name"
                />
              </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-justify="center">
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-xs="12"
                vs-sm="3"
                vs-lg="3"
              >
                <vs-button
                  class="w-full mx-2"
                  type="filled"
                  color="#626262"
                  @click="close"
                >
                  {{ $t('close') | capitalize }}
                </vs-button>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-xs="12"
                vs-sm="3"
                vs-lg="3"
              >
                <vs-button
                  class="w-full mx-2"
                  type="filled"
                  color="primary"
                  :disabled="disabledSubmit"
                  @click="submit"
                >
                  {{ $t('submit') | capitalize }}
                </vs-button>
              </vs-col>
            </vs-row>
          </div>
        </form>
      </div>
    </vs-popup-custom>
  </div>
</template>
  
  <script>
import VsPopupCustom from '@/views/components/modals/VsPopupCustom.vue'
import loading from '@/mixins/Loading'
import vSelect from 'vue-select'
import document from '../../requests/document'
export default {
  components: {
    VsPopupCustom,
    'v-select': vSelect,
  },
  computed: {
    disabledSubmit: function () {
      return (
        this.form.name === '' ||
        this.form.frequency === null ||
        this.form.frequency.trim() === ''
      )
    },
  },
  data() {
    return {
      loadingPage: 'document-modal-loading',
      form: {
        id: '',
        name: '',
        frequency: '',
      },
    }
  },
  methods: {
    close: function () {
      this.$emit('input', false)
    },
    submit: function () {
      let { id, name, frequency } = this.form
      if (id === '') {
        this.store({ name, frequency })
        return
      }
      this.update(id, { name, frequency })
      return
    },
    store: function (data) {
      this.openLoading(this.loadingPage)
      document
        .store(data)
        .then((response) => {
          this.closeLoading(this.loadingPage)
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Document Added',
          })
          this.$emit('input', false)
          this.$emit('refresh', false)
        })
        .catch((response) => {
          this.closeLoading(this.loadingPage)
          this.showValidationErrors(response)
        })
    },
    update: function (id, data) {
      this.openLoading(this.loadingPage)
      document
        .update(id, data)
        .then((response) => {
          this.closeLoading(this.loadingPage)
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Document Updated',
          })
          this.$emit('input', false)
          this.$emit('refresh', false)
        })
        .catch((response) => {
          this.closeLoading(this.loadingPage)
          this.showValidationErrors(response)
        })
    },
  },
  mixins: [loading],
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: Boolean,
      default: false,
    },
    frequencies: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    value(val) {
      if (val) {
        if (Object.keys(this.item).length) {
          let { id, name, frequency_id} = this.item
          this.form = Object.assign({ id, name, frequency:frequency_id })
        } else {
          this.form = Object.assign({ id: '', name: '', frequency: '' })
        }
      }
    },
  },
}
</script>
  
  <style>
.select-h > .vs__dropdown-menu {
  height: 50px;
}
</style>